import { Link, withRouter } from "react-router-dom";
import React from "react";

/**
 * Wraps the React Router Link component and creates a delay after the link is clicked.
 * Uses withRouter HOC (react-router-dom v5) instead of the legacy context.router API.
 */
class DelayLink extends React.Component {
    static defaultProps = {
        delay: 0,
        onDelayStart: () => {},
        onDelayEnd: () => {}
    };

    constructor(props) {
        super(props);
        this.timeout = null;
    }

    componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }

    handleClick = e => {
        // history is now injected via withRouter HOC instead of this.context.router
        const { replace, to, delay, onDelayStart, onDelayEnd, history } = this.props;

        if (this.props.clickAction) {
            this.props.clickAction();
        }
        onDelayStart(e, to);
        if (e.defaultPrevented) {
            return;
        }
        e.preventDefault();
        this.timeout = setTimeout(() => {
            if (replace) {
                history.replace(to);
            } else {
                history.push(to);
            }
            onDelayEnd(e, to);
        }, delay);
    };

    render() {
        // Strip out props injected by withRouter so they don't get spread onto <Link>
        const { delay, onDelayStart, onDelayEnd, clickAction, history, location, match, staticContext, ...rest } = this.props;
        return <Link {...rest} onClick={this.handleClick} />;
    }
}

export default withRouter(DelayLink);
